import { withAlpha } from '../utils/with-alpha';

export const semanticTokens = {
  colors: {
    'chakra-body-text': {
      _light: 'neutral.fg-primary',
      _dark: 'neutral.fg-primary',
    },
    'chakra-body-bg': {
      _light: 'neutral.bg-primary',
      _dark: 'neutral.bg-primary',
    },
    'chakra-border-color': {
      _light: 'neutral.border-base',
      _dark: 'neutral.border-base',
    },
    'chakra-inverse-text': {
      _light: 'neutral-invert.fg-primary',
      _dark: 'neutral-invert.fg-primary',
    },
    'chakra-subtle-bg': {
      _light: 'neutral.bg-secondary',
      _dark: 'neutral.bg-secondary',
    },
    'chakra-subtle-text': {
      _light: 'neutral.fg-secondary',
      _dark: 'neutral.fg-secondary',
    },
    'chakra-placeholder-color': {
      _light: 'neutral.fg-disabled',
      _dark: 'neutral.fg-disabled',
    },
    neutral: {
      'fg-primary': {
        _light: 'grey.900',
        _dark: 'grey.25',
      },
      'fg-secondary': {
        _light: 'blackAlpha.600',
        _dark: 'whiteAlpha.700',
      },
      'fg-tertiary': {
        _light: 'blackAlpha.400',
        _dark: 'whiteAlpha.500',
      },
      'fg-disabled': {
        _light: 'blackAlpha.300',
        _dark: 'whiteAlpha.400',
      },
      'solid-primary': {
        _light: 'grey.900',
        _dark: 'grey.25',
      },
      'solid-hover': {
        _light: 'grey.800',
        _dark: 'grey.100',
      },
      'solid-muted': {
        _light: 'grey.400',
        _dark: 'grey.600',
      },
      'border-subtle': {
        _light: 'blackAlpha.100',
        _dark: 'whiteAlpha.100',
      },
      'border-base': {
        _light: 'blackAlpha.200',
        _dark: 'whiteAlpha.200',
      },
      'fill-subtle': {
        _light: 'blackAlpha.25',
        _dark: 'whiteAlpha.100',
      },
      'fill-active': {
        _light: 'blackAlpha.50',
        _dark: 'whiteAlpha.200',
      },
      'bg-primary': {
        _light: 'white',
        _dark: 'black',
      },
      'bg-secondary': {
        _light: 'grey.25',
        _dark: 'grey.950',
      },
      'bg-tertiary': {
        _light: 'grey.50',
        _dark: 'grey.900',
      },
      'bg-overlay': {
        _light: 'blackAlpha.400',
        _dark: 'blackAlpha.500',
      },
    },
    'neutral-invert': {
      'fg-primary': {
        _light: 'white',
        _dark: 'black',
      },
      'fg-secondary': {
        _light: 'whiteAlpha.700',
        _dark: 'blackAlpha.600',
      },
      'fg-tertiary': {
        _light: 'whiteAlpha.500',
        _dark: 'blackAlpha.400',
      },
      'fg-quaternary': {
        _light: 'whiteAlpha.400',
        _dark: 'blackAlpha.300',
      },
      'solid-primary': {
        _light: 'white',
        _dark: 'black',
      },
      'border-subtle': {
        _light: 'whiteAlpha.200',
        _dark: 'blackAlpha.100',
      },
      'border-base': {
        _light: 'white',
        _dark: 'black',
      },
    },
    brand: {
      'fg-primary': {
        _light: 'blue.500',
        _dark: 'blue.400',
      },
      'fg-secondary': {
        _light: withAlpha('blue.500', 88),
        _dark: withAlpha('blue.500', 88),
      },
      'solid-primary': {
        _light: 'blue.500',
        _dark: 'blue.500',
      },
      'solid-hover': {
        _light: 'blue.600',
        _dark: 'blue.600',
      },
      'border-subtle': {
        _light: withAlpha('blue.500', 12),
        _dark: withAlpha('blue.400', 40),
      },
      'border-base': {
        _light: 'blue.500',
        _dark: 'blue.500',
      },
      'fill-subtle': {
        _light: withAlpha('blue.500', 8),
        _dark: withAlpha('blue.500', 20),
      },
      'fill-hover': {
        _light: withAlpha('blue.500', 12),
        _dark: withAlpha('blue.500', 28),
      },
      'bg-primary': {
        _light: 'blue.25',
        _dark: 'blue.950',
      },
      'bg-secondary': {
        _light: 'blue.50',
        _dark: 'blue.900',
      },
    },
    positive: {
      'fg-primary': {
        _light: 'green.600',
        _dark: 'green.500',
      },
      'fg-secondary': {
        _light: withAlpha('green.600', 88),
        _dark: withAlpha('green.600', 88),
      },
      'solid-primary': {
        _light: 'green.500',
        _dark: 'green.500',
      },
      'solid-hover': {
        _light: 'green.600',
        _dark: 'green.600',
      },
      'border-subtle': {
        _light: withAlpha('green.500', 16),
        _dark: withAlpha('green.500', 20),
      },
      'border-base': {
        _light: 'green.500',
        _dark: 'green.500',
      },
      'fill-subtle': {
        _light: withAlpha('green.500', 8),
        _dark: withAlpha('green.500', 16),
      },
      'fill-hover': {
        _light: withAlpha('green.500', 12),
        _dark: withAlpha('green.500', 20),
      },
      'bg-primary': {
        _light: 'green.25',
        _dark: 'green.950',
      },
      'bg-secondary': {
        _light: 'green.50',
        _dark: 'green.900',
      },
    },
    warning: {
      'fg-primary': {
        _light: 'orange.500',
        _dark: 'orange.500',
      },
      'fg-secondary': {
        _light: withAlpha('orange.500', 72),
        _dark: withAlpha('orange.500', 72),
      },
      'solid-primary': {
        _light: 'orange.500',
        _dark: 'orange.500',
      },
      'solid-hover': {
        _light: 'orange.600',
        _dark: 'orange.600',
      },
      'border-subtle': {
        _light: withAlpha('orange.500', 20),
        _dark: withAlpha('orange.500', 28),
      },
      'border-base': {
        _light: 'orange.500',
        _dark: 'orange.500',
      },
      'fill-subtle': {
        _light: withAlpha('orange.500', 8),
        _dark: withAlpha('orange.500', 16),
      },
      'fill-hover': {
        _light: withAlpha('orange.500', 12),
        _dark: withAlpha('orange.500', 20),
      },
      'bg-primary': {
        _light: 'orange.25',
        _dark: 'orange.950',
      },
      'bg-secondary': {
        _light: 'orange.50',
        _dark: 'orange.900',
      },
    },
    negative: {
      'fg-primary': {
        _light: 'red.500',
        _dark: 'red.500',
      },
      'fg-secondary': {
        _light: withAlpha('red.500', 72),
        _dark: withAlpha('red.500', 72),
      },
      'solid-primary': {
        _light: 'red.500',
        _dark: 'red.500',
      },
      'solid-hover': {
        _light: 'red.600',
        _dark: 'red.600',
      },
      'border-subtle': {
        _light: withAlpha('red.500', 16),
        _dark: withAlpha('red.500', 40),
      },
      'border-base': {
        _light: 'red.500',
        _dark: 'red.500',
      },
      'fill-subtle': {
        _light: withAlpha('red.500', 8),
        _dark: withAlpha('red.500', 16),
      },
      'fill-hover': {
        _light: withAlpha('red.500', 12),
        _dark: withAlpha('red.500', 20),
      },
      'bg-primary': {
        _light: 'red.25',
        _dark: 'red.950',
      },
      'bg-secondary': {
        _light: 'red.50',
        _dark: 'red.900',
      },
    },
    gold: {
      'fg-primary': {
        _light: 'gold.600',
        _dark: 'gold.500',
      },
      'fg-secondary': {
        _light: withAlpha('gold.600', 88),
        _dark: withAlpha('gold.500', 72),
      },
      'solid-primary': {
        _light: 'gold.500',
        _dark: 'gold.500',
      },
      'solid-hover': {
        _light: 'gold.600',
        _dark: 'gold.600',
      },
      'border-subtle': {
        _light: withAlpha('gold.500', 28),
        _dark: withAlpha('gold.500', 28),
      },
      'border-base': {
        _light: 'gold.500',
        _dark: 'gold.500',
      },
      'fill-subtle': {
        _light: withAlpha('gold.500', 16),
        _dark: withAlpha('gold.500', 16),
      },
      'fill-hover': {
        _light: withAlpha('gold.500', 20),
        _dark: withAlpha('gold.500', 20),
      },
      'bg-primary': {
        _light: 'gold.25',
        _dark: 'gold.950',
      },
      'bg-secondary': {
        _light: 'gold.50',
        _dark: 'gold.900',
      },
    },
    misc: {
      'white-fix-primary': {
        _light: 'white',
        _dark: 'white',
      },
      'white-fix-secondary': {
        _light: 'whiteAlpha.800',
        _dark: 'whiteAlpha.800',
      },
      'black-fix-primary': {
        _light: 'grey.900',
        _dark: 'grey.900',
      },
      'black-fix-secondary': {
        _light: 'blackAlpha.600',
        _dark: 'blackAlpha.600',
      },
      none: {
        _light: 'whiteAlpha.25',
        _dark: 'blackAlpha.25',
      },
    },
  },
};
